import React from 'react';
import { Modal, Button } from 'antd';
import './ConfirmationModal.css';

const ConfirmationModal = ({
    visible,
    onConfirm,
    onCancel,
    title = 'Confirm Submission',
    content = 'Are you sure you want to submit this timesheet for approval?',
    subContent = 'Please verify that all hours and reasons are correctly entered before proceeding.',
    okText = 'Yes, Submit',
    cancelText = 'No, Cancel',
    loading = false
}) => {
    const handleCancel = () => {
        if (!loading) {
            onCancel();
        }
    };

    return (
        <Modal
            className="confirmation-modal"
            title={title}
            open={visible}
            onCancel={handleCancel}
            closable={!loading}
            maskClosable={!loading}
            footer={[
                <Button key="cancel" onClick={handleCancel} disabled={loading}>
                    {cancelText}
                </Button>,
                <Button 
                    key="submit" 
                    type="primary" 
                    onClick={onConfirm} 
                    loading={loading}
                    disabled={loading}
                >
                    {okText}
                </Button>
            ]}
        >
            <div className="modal-content">
                <p className="main-content">{content}</p>
                <p className="sub-content">{subContent}</p>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;
